import { Spinner } from 'react-bootstrap';

function ComponentLoader({ isLoading }) {
    if (isLoading){
        return <div className="component-loader"><Spinner animation="border" role="status"><span className="visually-hidden">Loading...</span></Spinner></div>
    }
    return null
}
export default ComponentLoader;